// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".completion-info[data-v-ad2217c0]{color:#9c9c9c;font-size:16px}.completion-info__assistance[data-v-ad2217c0]{text-transform:lowercase}\n", ""]);
// Exports
module.exports = exports;
